import React, { useState, useEffect, Fragment, useRef } from "react";

import GoogleMapReact from "google-map-react";

const MapPinForm = (props) => {
  const { locationData, onChange, gmapApiKey } = props;
  const defaultCenter = locationData.lat
    ? { lat: locationData.lat, lng: locationData.lng }
    : { lat: 37.793601, lng: -122.399185 };
  const [markerPos, setMarkerPos] = useState({ ...defaultCenter });
  const [marker, setMarker] = useState(null);
  const mapRef = useRef();
  const apiIsLoaded = ({ map, maps, places }) => {
    mapRef.current = map;

    const marker = new maps.Marker({
      position: { ...markerPos },
      map,
      draggable: true,
      // icon:
    });
    setMarker(marker);
    const toggleBounce = () => {
      if (marker.getAnimation() !== null) {
        marker.setAnimation(null);
      } else {
        marker.setAnimation(google.maps.Animation.BOUNCE);
      }
    };
    marker.addListener("click", toggleBounce);
    google.maps.event.addListener(marker, "dragend", (mk) => {
      console.log("changed", locationData, mk.latLng);
      setMarkerPos({
        lat: mk.latLng.lat(),
        lng: mk.latLng.lng(),
      });
      onChange({
        ...locationData,
        lat: mk.latLng.lat(),
        lng: mk.latLng.lng(),
      });
    });
  };

  useEffect(() => {
    if (
      marker &&
      locationData &&
      markerPos.lat != locationData.lat &&
      markerPos.lng != locationData.lng
    ) {
      const latlng = new google.maps.LatLng(
        +locationData.lat,
        +locationData.lng
      );
      marker.setPosition(latlng);
      mapRef.current.setCenter(latlng);
    }
  }, [props.locationData.lat, props.locationData.lng]);

  return (
    <div style={{ height: 300, width: "100%" }}>
      <GoogleMapReact
        bootstrapURLKeys={{
          key: gmapApiKey,
          libraries: ["places", "geometry"],
        }}
        defaultCenter={defaultCenter}
        defaultZoom={10}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={apiIsLoaded}
        draggable={true}
        onChange={({ zoom, bounds }) => {}}
      ></GoogleMapReact>
    </div>
  );
};

export default MapPinForm;
